import { SelectionModel } from "@angular/cdk/collections";
import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { lastValueFrom } from "rxjs";
import { MODEL_EXPIRY_DAYS, ModelDetails, Organisation } from "../../common/organisation";
import { getUserRoleName } from "../../common/user";
import { ConfirmDialogComponent, ConfirmDialogModel } from "../../ui-components/dialogs/confirm-dialog.component";

class ModelRowData {
    constructor(public _key:string, public name:string, public functionName:string, public createdDate:Date, public deletedDate:Date, public access:string) {}
}

@Component({
    selector: 'restore-model-dialog',
    styleUrl: 'restore-model-table.css',
    templateUrl: 'restore-model-dialog.html',
    standalone: false
})
export class RestoreModelDialogComponent {
    modelColumns = ['select', 'name', 'functionName', 'createdDate', 'deletedDate', 'access'];
    modelColumnHeadings = ['', 'Name', 'Function', 'Created', 'Archived', 'Your access'];

    datasource = new MatTableDataSource<ModelRowData>();
    selection = new SelectionModel<ModelRowData>(true, []);
    expiryDays = MODEL_EXPIRY_DAYS

    constructor(private dialogRef: MatDialogRef<RestoreModelDialogComponent>, private dialog:MatDialog, @Inject(MAT_DIALOG_DATA) public organisation: Organisation) {
        this.datasource.data = organisation.models
            .filter(m => m.deletedDate)
            // most recently archived first
            .sort((a, b) => new Date(b.deletedDate).getTime() - new Date(a.deletedDate).getTime())
            .map(m => new ModelRowData(m._key, m.name, m.function, m.createdDate, m.deletedDate, this.getAccess(m)))
    }

    selectRow(row:ModelRowData) {
        this.selection.toggle(row)
    }

    isAllSelected() {
        return this.datasource.data.length > 0 && this.selection.selected.length === this.datasource.data.length
    }

    toggleAll() {
        if (this.isAllSelected()) this.selection.clear()
        else this.selection.select(...this.datasource.data)
    }

    getAccess(model:ModelDetails) {
        return getUserRoleName(model.role)
    }

    onCancelClick(): void {
        this.dialogRef.close();
    }

    restore() {
        this.dialogRef.close({action:"archive", models:this.selection.selected.map(m => m._key)});
    }

    async deletePermanently() {
        const count = this.selection.selected.length
        const message = `Permanently delete ${count === 1 ? this.selection.selected[0].name : count + ' models'}? ${count === 1 ? 'It' : 'They'} can't be restored afterwards.`
        const dialogData = new ConfirmDialogModel("Delete permanently", [message], "delete", false, "Delete", "Cancel")
        const result = await lastValueFrom(this.dialog.open(ConfirmDialogComponent, { maxWidth: "450px", data: dialogData }).afterClosed())
        if (result?.button === "Delete") {
            this.dialogRef.close({action:"delete", models:this.selection.selected.map(m => m._key)});
        }
    }
}
